module.exports = __webpack_public_path__ + "img/pick3_yellow.f749b9cf.png";